import React from 'react'
import { Box, Stack, Group, Text, Sx } from '@mantine/core'
import { Campaign } from 'types/domain'
import { get } from 'lodash-es'
import { Column, RowData } from 'components/ui/ScrollableTable'

type Props = {
  data: RowData[]
  onItemClick: (campaign: Campaign) => void
  columns: Column[]
  itemStyle?: (data: RowData) => Sx
}

const ListBody = ({ data, onItemClick, itemStyle, columns }: Props) => {
  return (
    <Stack spacing="lg">
      {data.map((dataItem, index) => {
        return (
          <Group
            noWrap
            key={index}
            position="apart"
            sx={itemStyle?.(dataItem)}
            onClick={() => {
              onItemClick?.(dataItem.rawData)
            }}
          >
            {columns.map((column) => {
              const { dataPath, minWidth, maxWidth, width, flex, cellStyle, cellRenderer } = column
              return (
                <Box key={`body-cell-${dataPath}`} style={{ minWidth, maxWidth, width, flex, ...cellStyle }}>
                  <Text lineClamp={1}>
                    {!!cellRenderer ? cellRenderer(dataItem, column) : get(dataItem, dataPath ?? '')}
                  </Text>
                </Box>
              )
            })}
          </Group>
        )
      })}
    </Stack>
  )
}

export default ListBody
